(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const rows = [...root.querySelectorAll('[data-wholesale-row]')];
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents/100);
    const rateFor = qty => qty >= 100 ? .40 : qty >= 50 ? .35 : qty >= 6 ? .30 : 0;
    const qtyOf = row => Math.max(0,Math.min(9999,parseInt(row.querySelector('[data-qty]').value,10)||0));
    const totalQty = root.querySelector('[data-total-qty]');
    const totalSavings = root.querySelector('[data-total-savings]');
    const totalPrice = root.querySelector('[data-total-price]');
    const addButton = root.querySelector('[data-add-all]');
    const message = root.querySelector('[data-wholesale-message]');
    let busy = false;
    function render() {
      let units=0,savings=0,total=0;
      rows.forEach(row => {
        const q=qtyOf(row), price=Number(row.dataset.price), rate=rateFor(q);
        const unit=Math.round(price*(1-rate)), line=unit*q;
        units+=q; savings+=price*q-line; total+=line;
        const field=row.querySelector('[data-qty]');
        if (document.activeElement !== field) field.value=q;
        row.querySelector('[data-unit-price]').textContent=money(unit);
        row.querySelector('[data-line-total]').textContent=money(line);
        row.classList.toggle('has-quantity',q>0);
      });
      totalQty.textContent=units;
      totalSavings.textContent=money(savings);
      totalPrice.textContent=money(total);
      addButton.disabled=busy || !units;
    }
    root.addEventListener('click',event=>{
      const btn=event.target.closest('[data-qty-minus],[data-qty-plus]');
      if(!btn || busy) return;
      const input=btn.closest('[data-wholesale-row]').querySelector('[data-qty]');
      input.value=Math.max(0,Math.min(9999,(parseInt(input.value,10)||0)+(btn.hasAttribute('data-qty-plus')?1:-1)));
      render();
    });
    root.addEventListener('input',event=>{if(event.target.matches('[data-qty]'))render();});
    root.addEventListener('change',event=>{if(event.target.matches('[data-qty]')){event.target.value=qtyOf(event.target.closest('[data-wholesale-row]'));render();}});
    addButton.addEventListener('click',async()=>{
      if(busy)return;
      const items=rows.filter(row=>qtyOf(row)>0).map(row=>({id:Number(row.dataset.variantId),quantity:qtyOf(row)}));
      if(!items.length)return;
      busy=true;addButton.textContent='ADDING TO BAG…';message.textContent='';render();
      try {
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Unable to add items.');
        rows.forEach(row=>{row.querySelector('[data-qty]').value=0;});
        document.dispatchEvent(new CustomEvent('hbca:cart:updated',{detail:result}));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href=(window.Shopify?.routes?.root||'/')+'cart';
      }catch(error){message.textContent=error.message||'Please try again.';}
      finally{busy=false;addButton.textContent='ADD ALL TO BAG →';render();}
    });
    render();
  }
  document.querySelectorAll('[data-hbca-wholesale]').forEach(init);
})();
